<template>
  <div>
    <div class="white-section mt-1" style="padding: 10px 20px">
      <div class="d-flex justify-content-end">
        <div style="margin-left: auto" class="page-title"></div>
        <b-row class="mt-1 mb-3 search-box d-flex justify-content-between">
          <b-col md="12" class="col-add">
            <div class="controls" v-if="showCalendar">
              <button @click="prevYear">سال قبل</button>
              <h1>| {{ yearHoliday }} |</h1>
              <button @click="nextYear">سال بعد</button>
            </div>
            <div class="form-group w-50">
              <b-form-input
                v-model="searchTerm"
                :placeholder="$t('general.search')"
                type="text"
                class="d-inline-block"
                v-if="holidayShow"
              />
            </div>
            <!-- <router-link
              tag="button"
              :to="{ name: 'addHoliday' }"
              class="btn btn-success btn-add"
              >{{ $t("general.add") }}
            </router-link> -->
            <button class="btn btn-danger" v-if="showCalendar" @click="showListHoliday">
              لیست تعطیلات
            </button>
            <button
              class="btn btn-success"
              v-if="holidayShow"
              @click="showListHoliday"
              style="height: 40px; width: 130px"
            >
              نمایش تقویم
            </button>
          </b-col>
        </b-row>
      </div>
      <b-row v-if="showCalendar">
        <b-col md="12">
          <div class="calendar">
            <div v-for="(month, index) in months" :key="index" class="month-container">
              <h2>{{ month.name }}</h2>
              <table>
                <thead>
                  <tr>
                    <th v-for="day in days" :key="day">{{ day }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(week, weekIndex) in month.weeks" :key="weekIndex">
                    <td
                      v-for="(day, dayIndex) in week"
                      :key="dayIndex"
                      :id="day.date"
                      @click="selectDay(day)"
                    >
                      {{ day.day }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-col>
      </b-row>
      <!-- table -->

      <vue-good-table
        v-if="holidayShow"
        class="user-table"
        :columns="columns"
        :rows="holidayData"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
          mode: 'pages',
        }"
        :search-options="{
          enabled: false,
          externalQuery: searchTerm,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'mydate'" class="text-nowrap">
            <span v-if="props.row.date"> {{ dateToPersian(props.row.date) }}</span>
          </span>

          <!-- Column: Action -->
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item @click="editHolidays(props.row)">
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>{{ $t("general.edit") }}</span>
                </b-dropdown-item>
                <b-dropdown-item @click="removeHoliday(props.row)">
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>{{ $t("general.delete") }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>
          <!-- Column: Common -->
          <span v-else-if="props.column.field === 'sectionId' && props.row.sectionId">
            {{ props.row.getSection.title }}
          </span>
          <span v-else-if="props.column.field === 'createAutomaticRecallNumber'">
            {{
              props.row.createAutomaticRecallNumber == true
                ? $t("unit.createAutomaticRecallNumber")
                : $t("unit.createCustomRecallNumber")
            }}
          </span>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap">
                {{ $t("general.pageLength") }}
              </span>
              <b-form-select
                v-model="pageLength"
                :options="['20', '50', '100']"
                class="mx-1"
                @change="handlePageChange"
              />
              <span class="text-nowrap">
                {{ $t("general.of") }} {{ total }} {{ $t("general.pageText2") }}
              </span>
            </div>
            <div>
              <b-pagination
                v-model="page"
                :total-rows="total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @change="handlePageChange"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
    </div>
    <!-- addHolidayModal -->
    <div class="modal modalhistory" tabindex="-1" v-if="showAddHoliday">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">افزودن تعطیلی</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="showAddHoliday = !showAddHoliday"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$t('holiday.descriptionCalendar')"
                  label-for="holiday-desc"
                >
                  <textarea
                    name=""
                    v-model="descriptionCalendar"
                    id="holiday-desc"
                    class="form-control"
                    style="min-height: 100px"
                  ></textarea>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('holiday.descriptionCenter')"
                  label-for="holiday-description"
                >
                  <textarea
                    name=""
                    v-model="description"
                    id="holiday-description"
                    class="form-control"
                    style="min-height: 100px"
                  ></textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="d-flex justify-content-end">
              <b-button class="btn btn-success" @click="addHoliday">
                {{ $t("general.submit") }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- edit Holiday & delete -->
    <div class="modal modalhistoryEdit" tabindex="-1" v-if="showEditHoliday">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">ویرایش تعطیلی</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="showEditHoliday = !showEditHoliday"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$t('holiday.descriptionCalendar')"
                  label-for="holiday-desc"
                >
                  <textarea
                    name=""
                    v-model="descriptionCalendar"
                    id="holiday-desc"
                    class="form-control"
                    style="min-height: 100px"
                  ></textarea>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :label="$t('holiday.descriptionCenter')"
                  label-for="holiday-description"
                >
                  <textarea
                    name=""
                    v-model="description"
                    id="holiday-description"
                    class="form-control"
                    style="min-height: 100px"
                  ></textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="d-flex justify-content-end">
              <b-button class="btn btn-danger mr-2 ml-2" @click="deleteHoliday">
                {{ $t("general.delete") }}
              </b-button>
              <b-button class="btn btn-success" @click="holidayEdit">
                {{ $t("general.submit") }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BBreadcrumb, BBreadcrumbItem } from "bootstrap-vue";
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BAlert,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BRow,
  BCol,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import moment from "jalali-moment";
import dateFormat from "@/mixins/dateFormat";
import jalaliMoment from "jalali-moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { CloudDrizzleIcon } from "vue-feather-icons";

export default {
  mixins: [dateFormat],
  components: {
    MyVSelect,
    BBreadcrumb,
    BBreadcrumbItem,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BRow,
    BCol,
    moment,
    jalaliMoment,
    ToastificationContent,
  },
  data() {
    return {
      pageLength: 100,
      page: 1,
      dir: false,
      total: "",
      searchTimer: null,
      selectedDate: "",
      description: "",
      descriptionCalendar: "",
      holidayShow: false,
      showCalendar: true,
      months: [],
      days: ["ش", "ی", "د", "س", "چ", "پ", "ج"],
      currentYear: moment().jYear(),
      showAddHoliday: false,
      showEditHoliday: false,
      bgHoliday: false,
      selectedDay: "",
      holidays: [],
      payload: {},
      DateH: "",
      yearHoliday: "",
      dateHoliday: "",
      resHolidayes: "",
      idTdHoliday: "",
      foundId: "",
      columns: [
        {
          label: this.$t("holiday.date"),
          field: "mydate",
        },
        {
          label: this.$t("holiday.descriptionCalendar"),
          field: "descriptionCalendar",
        },
        {
          label: this.$t("holiday.descriptionCenter"),
          field: "descriptionCenter",
        },
        {
          label: "عملیات",
          field: "action",
        },
      ],
      searchTerm: "",
      holidayData: {},
      holidayDates: "",
    };
  },
  methods: {
    generateMonths() {
      this.months = [];
      for (let i = 0; i < 12; i++) {
        const currentDate = moment();
        const currentMonth = currentDate.jMonth();
        const targetMonth = currentDate.jMonth(i).jYear(this.currentYear);
        const firstDayOfMonth = moment()
          .jMonth(i)
          .startOf("jMonth")
          .jYear(this.currentYear);
        const lastDayOfMonth = moment().jMonth(i).endOf("jMonth").jYear(this.currentYear);
        const daysInMonth = lastDayOfMonth.jDate();
        const firstDayOfWeek = firstDayOfMonth.jDay();
        const weeks = [];
        let currentWeek = [];
        for (let j = 0; j < firstDayOfWeek; j++) {
          currentWeek.push({});
        }
        for (let day = 1; day <= daysInMonth; day++) {
          const currentDate = targetMonth.jDate(day);
          const isCurrentMonth = i === currentMonth;
          currentWeek.push({
            day,
            isCurrentMonth,
            date: currentDate.format("jYYYY/jM/jD"),
          });

          if (currentWeek.length === 7) {
            weeks.push([...currentWeek]);
            currentWeek = [];
          }
        }
        if (currentWeek.length > 0) {
          weeks.push([...currentWeek]);
        }
        this.months.push({
          name: firstDayOfMonth.locale("fa").format("jMMMM"),
          year: firstDayOfMonth.format("jYYYY"),
          weeks,
        });
      }
      this.yearHoliday = this.months[0].year;
    },
    prevYear() {
      this.currentYear -= 1;
      this.generateMonths();
      this.showCalendar = false;
      // this.searchUser();
      setTimeout(() => {
        this.searchUser();
        this.showCalendar = true;
      }, 80);
    },
    nextYear() {
      this.currentYear += 1;
      this.generateMonths();
      this.showCalendar = false;
      // this.searchUser();
      setTimeout(() => {
        this.searchUser();
        this.showCalendar = true;
      }, 80);
    },
    selectDay(day) {
      this.selectedDay = moment(day.date, "jYYYY/jM/jD").format("YYYY-MM-DD");
     if(day.date){
       this.showAddHoliday = true;
     }
      this.descriptionCenter = "";
      this.descriptionCalendar = "";
      this.description = "";
      let foundDate = null;
      for (let i = 0; i < this.resHolidayes.data.length; i++) {
        const date = moment(this.resHolidayes.data[i].date).locale("fa").format("YYYY/MM/DD");
        if (date === moment(this.selectedDay).locale("fa").format("YYYY/MM/DD")) {
          foundDate = date;
          this.foundId = this.resHolidayes.data[i]._id;
          break;
        }
    }

      if (foundDate) {
        this.showAddHoliday = false;
        this.showEditHoliday = true;
        this.getData();
      }
    },

    showListHoliday() {
      this.showCalendar = !this.showCalendar;
      this.holidayShow = !this.holidayShow;
      this.pageLength = 100;

      // this.searchUser();
    },
    addHoliday() {
      this.payload = {
        date: moment(this.selectedDay).format("YYYY-MM-DD"),
        descriptionCalendar: this.descriptionCalendar,
        descriptionCenter: this.description,
        status: "active",
      };
      this.$store.commit("SET_IS_LOADING", true);
      this.showAddHoliday = false;
      if (
        this.description === "" ||
        this.descriptionCalendar === "" ||
        (this.descriptionCalendar === "" && this.description === "")
      ) {
        this.$bvToast.toast(this.$t("toastification.completeBlanks"), {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
        this.$store.commit("SET_IS_LOADING", false);
        this.showAddHoliday = true;
      } else {
        this.$store
          .dispatch("holiday/AddHoliday", this.payload)
          .then((response) => {
            if (response) {
              this.holidays = response;
              this.searchUser();
              this.$store.commit("SET_IS_LOADING", false);
              this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
                variant: "success",
                solid: true,
              });

              this.showAddHoliday = false;
              this.selectedDay = "";
              this.descriptionCenter = "";
              this.descriptionCalendar = "";
              this.description = "";
              this.$router.push({ name: "manageHolidays" });
            }
          })
          .catch((error) => {
            this.$bvToast.toast(this.$t("toastification.dateNotSelected"), {
              title: this.$t("toastification.error"),
              variant: "danger",
              solid: true,
            });

            this.bgHoliday = false;
            this.selectedDay = "";
            this.descriptionCenter = "";
            this.descriptionCalendar = "";
            this.showAddHoliday = false;
            this.description = "";
          })
          .finally(() => {
            this.$store.commit("SET_IS_LOADING", false);
          });
      }
    },
    isHighlighted(day) {
      const formattedDay = moment(day.date).format("YYYY-MM-DD");
      return formattedDay === this.selectedDay;
    },
    handlePageChange() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    removeItem(index) {
      this.holidayData.splice(index, 1);
    },
    removeHoliday(row) {
      const id = row._id;
      this.$bvModal
        .msgBoxConfirm(this.$t("general.confirmDelete"), {
          title: this.$t("general.confirmDeleteTitle"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("general.yes"),
          cancelTitle: this.$t("general.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.$store.commit("SET_IS_LOADING", true);
            this.$store
              .dispatch("holiday/deleteHoliday", { id: id })
              .then((res) => {
                this.$bvToast.toast(this.$t("toastification.deletionSucceed"), {
                  title: this.$t("toastification.success"),
                  variant: "success",
                  solid: true,
                });
                this.removeItem(row.originalIndex);
                this.$store.commit("SET_IS_LOADING", false);
              })
              .catch((error) => {
                let msg = "";
                switch (error.response.status) {
                  case 422:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 404:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 400:
                    msg = this.$t("toastification.badRequest");
                    break;
                }

                this.$bvToast.toast(msg, {
                  title: this.$t("toastification.error"),
                  variant: "danger",
                  solid: true,
                });
                this.$store.commit("SET_IS_LOADING", false);
              });
          }
        })
        .catch((err) => {
          alert("error");
        });
    },

    editHolidays(row) {
      this.$router.push({ name: "editHoliday", params: { id: row._id } });
    },
    getData() {
      const id = this.foundId;
      this.$store.dispatch("holiday/findHoliday", id).then((res) => {
        this.selectedDate = res.date;
        this.description = res.descriptionCenter;
        this.descriptionCalendar = res.descriptionCalendar;
      });
    },
    holidayEdit() {
      if (this.selectedDate) {
        const payload = {
          date: moment(this.selectedDay).format("YYYY-MM-DD"),
          descriptionCalendar: this.descriptionCalendar,
          descriptionCenter: this.description,
          status: "active",
        };
        this.$store.commit("SET_IS_LOADING", true);
        this.$store
          .dispatch("holiday/UpdateHoliday", {
            id: this.foundId,
            payload: payload,
          })
          .then((res) => {
            this.$store.commit("SET_IS_LOADING", false);
            this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
              title: this.$t("toastification.success"),
              variant: "success",
              solid: true,
            });
            this.showEditHoliday = false;
            this.searchUser();
            this.$router.push({ name: "manageHolidays" });
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t("toastification.failedAction"),
                content: this.$t("toastification.failedAction"),
                icon: "EditIcon",
                variant: "danger",
              },
            });
            this.$store.commit("SET_IS_LOADING", false);
          });
      } else {
        this.$bvToast.toast(this.$t("toastification.dateNotSelected"), {
          title: this.$t("toastification.error"),
          variant: "danger",
          solid: true,
        });
      }
    },
    deleteHoliday() {
      const id = this.foundId;
      this.$bvModal
        .msgBoxConfirm(this.$t("general.confirmDelete"), {
          title: this.$t("general.confirmDeleteTitle"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("general.yes"),
          cancelTitle: this.$t("general.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.$store.commit("SET_IS_LOADING", true);
            this.$store
              .dispatch("holiday/deleteHoliday", { id: id })
              .then((res) => {
                this.$bvToast.toast(this.$t("toastification.deletionSucceed"), {
                  title: this.$t("toastification.success"),
                  variant: "success",
                  solid: true,
                });
                const tds = document.querySelectorAll("td");
                tds.forEach((td) => {
                  const id = td.id;
                  const idHoliMoment = moment(id, "jYYYY/jM/jD");
                  const selectedDayMoment = moment(this.selectedDay).locale("fa");
                  if (selectedDayMoment.isSame(idHoliMoment)) {
                    td.style.backgroundColor = "white";
                    td.style.color = "#9997a2";
                    this.searchUser();
                  }
                });
                this.showEditHoliday = false;
                this.$store.commit("SET_IS_LOADING", false);
              })
              .catch((error) => {
                let msg = "";
                switch (error.response.status) {
                  case 422:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 404:
                    msg = this.$t("toastification.deletionFailed");
                    break;

                  case 400:
                    msg = this.$t("toastification.badRequest");
                    break;
                }

                this.$bvToast.toast(msg, {
                  title: this.$t("toastification.error"),
                  variant: "danger",
                  solid: true,
                });
                this.$store.commit("SET_IS_LOADING", false);
              });
          }
        })
        .catch((err) => {
          alert("error");
        });
    },
     searchUser() {
        const payload = {
        page: this.page,
        limit: parseInt(this.pageLength),
        status: "active",
      };
        this.$store.commit("SET_IS_LOADING", true);
        this.$store.dispatch("holiday/SearchHoliday", payload).then((res) => {
          this.total = res.total;
          this.pageLength = payload.limit;
          this.resHolidayes = res;
         // sort Holidays
         this.holidayData = res.data.sort((a, b) => {
          const dateA = new Date(a.date);
          const dateB = new Date(b.date);
          const timeDifference = dateB - dateA;
          return timeDifference;
        });
        this.$store.commit("SET_IS_LOADING", false);
        this.holidayDates = res.data
        .filter(
          (holiday) => moment(holiday.date).jYear() === parseInt(this.yearHoliday)
        )
        .map((date) => moment(date.date).locale("fa").format("YYYY/MM/DD"));
        // bg red
      const tds = document.querySelectorAll("td");
      tds.forEach((td) => {
        const id = td.id;
        const idHoli = id;
        const idHoliMoment = moment(idHoli, "jYYYY/jM/jD");
        const holidayDatesMoments = this.holidayDates.map((date) =>
          moment(date, "jYYYY/jM/jD")
        );
        if (holidayDatesMoments.some((date) => date.isSame(idHoliMoment))) {
          td.style.backgroundColor = "rgba(247, 69, 69, 0.66)";
          td.style.color = "white";
        }
      });
    });

    },
  },
  computed: {
    breadcrumb() {
      return typeof this.$route.meta.breadCrumb === "function"
        ? this.$route.meta.breadCrumb(this.$route)
        : this.$route.meta.breadCrumb;
    },
  },
  mounted() {
    this.generateMonths();
    if (localStorage.getItem("showHoliday")) {
      this.holidayShow = true;
      this.showCalendar = false;
    }
  },
  created() {
    this.searchUser();
    this.$store.commit("SET_IS_LOADING", true);
    this.setBreadcrumbs([
      { text: "homePage", translate: true, to: { name: "home" } },
      { text: "HolidaysMenu", to: { name: "manageHolidays" }, translate: true },
    ]);
    this.setCurrentBreadcrumb([
      { text: "HolidaysMenu", to: { name: "HolidaysMenu" }, translate: true },
    ]);
  },
  watch: {
    page() {
      this.searchUser();
    },
    pageLength() {
      this.page=1
      this.searchUser();
    },
    showCalendar() {
      localStorage.setItem("hideCalendar", this.showCalendar);
      if (this.showCalendar === true) {
        this.searchUser();
      }
    },
    holidayShow() {
      localStorage.setItem("showHoliday", this.holidayShow);
    },
  },
};
</script>

<style scoped>
.calendar {
  text-align: center;
  font-family: Arial, sans-serif;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
.calendar .month-container {
  width: 23%;
  margin-bottom: 10px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border: 2px solid #eaf0ff;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: unset;
}

.calendar table {
  width: 100%;
  border-collapse: initial;
  border-radius: unset;
  background: #eaf0ff !important;
}
.calendar h2 {
  font-size: 22px;
  font-weight: 500;
}
.calendar th,
td {
  padding: 10px;
}

.calendar th {
  background-color: #eee;
}

.calendar td {
  cursor: pointer;
}
.calendar tbody tr td {
  padding: 5px;
}
.calendar tbody tr td:nth-child(7) {
  background-color: rgba(247, 69, 69, 0.66);
  color: white;
  font-weight: 700;
}
.holiday {
  background-color: rgba(247, 69, 69, 0.66);
  color: white;
  font-weight: 700;
}

.btnCurrentMonth {
  padding: 5px;
  text-align: center;
  background: #02a49c;
  width: 100%;
  color: white;
  font-weight: 800;
  cursor: pointer;
  border-radius: 5px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.btnCurrentMonth:hover {
  transition: all 0.5s;
  background-color: #1fb9b2 !important;
  color: white;
  box-shadow: 0 8px 25px -8px #0198918c !important;
}
.col-add {
  justify-content: space-between;
  display: flex;
}
.styleCalendar {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.selected-day {
  background-color: red !important;
  color: white;
  cursor: pointer;
}
.controls {
  display: flex;
  justify-content: space-between;
  width: 26%;
}
.controls button {
  background-color: #02a49c !important;
  width: 78px;
  height: 35px;
  border-radius: 30px;
  color: white;
  font-weight: 600;
}
.controls button:hover {
  transition: all 0.5s;
  background-color: #1fb9b2 !important;
  color: white;
  box-shadow: 0 8px 25px -8px #0198918c !important;
}
.search-box {
  align-items: center;
  border: 1px solid #02a49c1a;
  border-radius: 15px;
  box-shadow: 5px 4px 6px -6px rgba(2, 164, 156, 0.43);
}
</style>
